import paymentActions from "./paymentActions";

const allPaymentsActions = {
  paymentActions,
};

export default allPaymentsActions;
